// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import useMergeProps from '../../../hooks/useMergeProps';
import { selectRuntimeLicence } from '../../../selectors/runtime/runtimePrimary.selector';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import MPCard from '../components/common/MPCard';
import { MPFamilies } from '../constants/families';
import { useMPFamilyContext } from '../contexts/MPFamilyContext';
import { selectMPUserCardStatus } from '../selectors/user';

type MPCardContainerProps = {
  className?: string;
  index: number;
};

const MPCardContainer = ({ index, ...ownProps }: MPCardContainerProps) => {
  const history = useHistory();

  const { familyId } = useMPFamilyContext();

  const selectorProps = useMemo(() => ({ familyId, index }), [familyId, index]);
  const status = useSelector((state) => selectMPUserCardStatus(state, selectorProps));

  const selectedProps = useMemo(() => ({ status }), [status]);

  const onClick = useCallback(() => {
    history.push(
      RoutesRedirectionFactory.getMPFamilyDetailRouteConfig(familyId, {
        state: {
          indexToSwipe: index,
        },
      }),
    );
  }, [history, familyId, index]);

  const cardInfos = useMemo(() => MPFamilies[familyId][index], [index, familyId]);
  const licence = useSelector(selectRuntimeLicence);
  const streetName = useMemo(() => cardInfos.nameCard[licence], [cardInfos, licence]);
  const cardType = useMemo(() => cardInfos.type, [cardInfos]);

  const otherProps = useMemo(
    () => ({ onClick, streetName, cardType, familyId }),
    [onClick, streetName, cardType, familyId],
  );

  const enhancedProps = useMergeProps({ selectedProps, ownProps, otherProps });

  return <MPCard {...enhancedProps} />;
};

export default MPCardContainer;
